import { render, staticRenderFns } from "./ApuracaoContrato.vue?vue&type=template&id=6f889994"
import script from "./ApuracaoContrato.vue?vue&type=script&lang=js"
export * from "./ApuracaoContrato.vue?vue&type=script&lang=js"
import style0 from "./ApuracaoContrato.vue?vue&type=style&index=0&id=6f889994&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports